import Luminary from '../index';
import { getResolutionValueFromVideoHeight } from '../libs/videoData';
import { sliceVideoData } from './sliceVideoData';
import type { OpaqueVideoData } from './types';

export async function determineResolutionFromVideoData(videoData: OpaqueVideoData) {
    const dataLuminary = new Luminary({
        disableRenderer: true,
        fetchResources: false,
    });
    const slicedData = sliceVideoData(videoData, {
        start: 0,
        end: 0,
        preserveTransitions: false,
    });
    dataLuminary.load(slicedData.videoData);
    const resolutionValue = getResolutionValueFromVideoHeight(
        dataLuminary.videoHeight,
        dataLuminary.aspectRatio
    );
    await dataLuminary.destroy();
    return resolutionValue;
}
